import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { userColumns } from './usersColumns';
import UsersTable from './usersTable/UsersTable';
import { UsersActions } from './usersTable/UsersActions';
import Select from 'react-select';
moment.locale('es');

const ListaUsuarios = ({ colaboradores, switchNewUser, setSwitchNewUser }) => {
  //UseStates
  const [filterUsers, setFilterUsers] = useState('all');
  const [searchUser, setSearchUser] = useState('');
  const [cleanList, setCleanList] = useState([]);
  const [data, setData] = useState([]);

  const statusOptions = [
    { value: 'active', label: 'Activos' },
    { value: 'pending', label: 'Pendientes' },
    { value: 'expired', label: 'Expirados' },
    { value: 'disabled', label: 'Deshabilitados' },
    { value: 'all', label: 'Todos' }
  ];

  //SetCollabs
  useEffect(() => {
    setCleanList(colaboradores);
  }, [colaboradores]);

  useEffect(() => {
    colaboradores.length > 0 && setCleanList(handleSearch);
  }, [searchUser, filterUsers]);

  useEffect(() => {
    setData(
      cleanList?.map(colab => {
        return {
          firstName: colab.firstName,
          lastName: colab.lastName,
          email: colab.email,
          dni: colab.dni,
          status: `${
            colab.status === 'pending'
              ? 'Pendiente'
              : colab.status === 'active'
              ? 'Activo'
              : colab.status === 'expired'
              ? 'Expirado'
              : colab.status === 'disabled' && 'Deshabilitado'
          }`,
          actions: (
            <UsersActions
              colab={colab}
              switchNewUser={switchNewUser}
              setSwitchNewUser={setSwitchNewUser}
            />
          )
        };
      })
    );
  }, [cleanList]);

  const handleSearch = () => {
    let colabs = colaboradores.length > 0 ? colaboradores : cleanList;
    if (filterUsers !== 'all') {
      colabs = colabs.filter(user => user.status === filterUsers);
    }
    if (searchUser !== '') {
      colabs = colabs.filter(user => {
        const completeName = `${user.firstName} ${user.lastName}`;
        return (
          completeName.toLowerCase().includes(searchUser?.toLowerCase()) ||
          user.email.toLowerCase().includes(searchUser?.toLowerCase()) ||
          user.dni.toLowerCase().includes(searchUser?.toLowerCase())
        );
      });
    }
    return colabs;
  };

  return (
    <>
      <div>
        <div
          className="mb-5 ms-3 d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-end"
          style={{ gap: '30px' }}
        >
          <div className="mb-3 mb-md-0 w-100 w-md-auto">
            <label>Filtrar por estado:</label>
            <Select
              options={statusOptions}
              value={statusOptions.find(option => option.value === filterUsers)}
              onChange={option => setFilterUsers(option.value)}
              styles={{
                container: base => ({
                  ...base,
                  width: '100%',
                  minWidth: '10rem'
                })
              }}
            />
          </div>
          <div className="mb-3 mb-md-0 w-100 w-md-auto">
            <input
              type="text"
              className="form-control form-control-sm w-100 w-md-auto mb-1"
              required
              id="lastname"
              aria-describedby="lastnameHelp"
              placeholder="Buscar usuario"
              value={searchUser}
              onChange={e => setSearchUser(e.target.value)}
            />
          </div>
        </div>

        {data && userColumns && (
          <UsersTable columns={userColumns} data={data} />
        )}
      </div>
    </>
  );
};

ListaUsuarios.propTypes = {
  colaboradores: PropTypes.array.isRequired,
  switchNewUser: PropTypes.bool.isRequired,
  setSwitchNewUser: PropTypes.func.isRequired
};

export default ListaUsuarios;
